/**
 * Get the appropriate author icon URL or placeholder based on theme
 * @param {Object} authorData - Author data containing authorIconUrl
 * @param {string} apiBaseUrl - Base URL for API calls
 * @param {string} theme - Current theme ('light' or 'dark')
 * @returns {string} - URL to the author icon or placeholder
 */
export function getAuthorIconUrl(authorData, apiBaseUrl, theme) {
    if (authorData?.authorIconUrl) {
        console.log('Author icon URL found:', authorData.authorIconUrl);
        // If the URL starts with /images/, it's a local file (demo mode), don't prepend API base URL
        if (authorData.authorIconUrl.startsWith('/images/')) {
            return authorData.authorIconUrl;
        }
        return apiBaseUrl + authorData.authorIconUrl;
    } else {
        return getAuthorPlaceholder(theme);
    }
}

/**
 * Get the appropriate author placeholder based on theme
 * @param {string} theme - Current theme ('light' or 'dark')
 * @returns {string} - Path to the appropriate placeholder
 */
export function getAuthorPlaceholder(theme) {
    return theme === 'dark' 
        ? '/images/author-placeholder-dark.svg' 
        : '/images/author-placeholder-light.svg';
}
